export enum ECountry {
	mexico = 'mexico',
}

export enum ETimeZone {
	mexico = 'America/Mexico_City',
}

export const COUNTRIES = [ECountry.mexico]

export enum EPhoneNumberCode {
	mexico = '+52',
}

export interface IPhoneNumberCode {
	code: EPhoneNumberCode
	country: ECountry
}
